"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_ADMIN_PERMISSIONS = exports.ADMIN_ROUTE_PERMISSIONS = void 0;
const enums_1 = require("../enums");
/** Maps admin panel routes to the permission required to access them. */
exports.ADMIN_ROUTE_PERMISSIONS = {
  '/admin/dashboard': enums_1.AdminPermission.Dashboard,
  '/admin/users': enums_1.AdminPermission.Users,
  '/admin/venues': enums_1.AdminPermission.Venues,
  '/admin/venue-activity': enums_1.AdminPermission.Visits,
  '/admin/user-interactions': enums_1.AdminPermission.Likes,
  '/admin/customers': enums_1.AdminPermission.Customers,
  '/admin/roles': enums_1.AdminPermission.Admin,
  '/admin/app-launches': enums_1.AdminPermission.AppLaunches,
  '/admin/audit-logs': enums_1.AdminPermission.AuditLogs,
  '/admin/feature-flags': enums_1.AdminPermission.FeatureFlags,
  '/admin/dev-telephones': enums_1.AdminPermission.DevTelephoneNumber,
  '/admin/reports': enums_1.AdminPermission.Reports,
  '/admin/jobs': enums_1.AdminPermission.Jobs,
  '/admin/notifications': enums_1.AdminPermission.Notifications,
  '/admin/comments': enums_1.AdminPermission.Comments,
  '/admin/map': enums_1.AdminPermission.Map,
  '/admin/intentions': enums_1.AdminPermission.Intentions,
  '/admin/venue-events': enums_1.AdminPermission.Events,
  '/admin/eventbrite': enums_1.AdminPermission.Venues,
  '/admin/system-status': enums_1.AdminPermission.SystemStatus,
  '/admin/photo-verification': enums_1.AdminPermission.PhotoVerification,
  '/admin/simulation': enums_1.AdminPermission.Simulation,
  '/admin/stickers': enums_1.AdminPermission.Stickers,
  '/admin/tickets': enums_1.AdminPermission.Tickets,
  '/admin/partnered-hotspots': enums_1.AdminPermission.Events
};
exports.ALL_ADMIN_PERMISSIONS = Object.values(enums_1.AdminPermission);
//# sourceMappingURL=admin-permissions.js.map